// extracted by mini-css-extract-plugin
export var articleCard = "article-card-module--article-card--9r8yg";
export var articleCardBannerImage = "article-card-module--article-card-banner-image--gq+Zb";
export var articleCardDate = "article-card-module--article-card-date--9n4VT";
export var articleCardFooter = "article-card-module--article-card-footer--4ucNk";
export var articleCardInnerContainer = "article-card-module--article-card-inner-container--EJPnq";
export var articleCardOverview = "article-card-module--article-card-overview--TKVpU";
export var articleCardTitle = "article-card-module--article-card-title--jzZPh";